import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import {useDispatch, useSelector} from "react-redux";
import { useSetState } from "Helpers/Hooks";
import AddressList from "Constants/AddressList";
import { read } from "Helpers/LocalStorage";
import { KeyGroup, KeyUser } from "Constants/Keys";
import { getAllMoshtariTblData, UpdateMoshtariData } from "Stores/actions";
import * as R from "ramda";
import showNotify from "Helpers/Notify";
import CustomerService from "Services/http/endpoints/customer/CustomerService";
import StatusHandler from "Helpers/StatusHandler";
import {DialogActions} from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import {convertToEnglishNumber} from "Helpers/convertToEnglishNumber";
import { useTranslation } from 'react-i18next';
import * as Icons from "react-bootstrap-icons";

function EditCustomer({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { customerDataPagination } = useSelector((state) => ({
    customerDataPagination: state.customer.customerDataPagination,
  }));
  const [showDialog, setShowDialog] = useState(false);
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: row.Name,
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    shomareEghtesadi: {
      type: "text",
      value: row.ShoEconomic,
      validation: null,
      col: {
        sm: 6,
        xs: 12,
      },
    },
    mobile: {
      type: "phone",
      value: row.Mobile,
      validation: {
        required: true,
        isNumeric: true,
        isPhone: true,
        minLength: 11,
      },
      col: {
        sm: 4,
        xs: 12,
      },
    },
    telephone: {
      type: "phone",
      value: row.Tell,
      validation: null,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    fax: {
      type: "phone",
      className: "phone",
      value: row.Fax,
      validation: null,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    customerGroup: {
      type: "select",
      selectItems: [],
      value: row.IdGroup,
      validation: null,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    ostan: {
      type: "select",
      selectItems: AddressList.Ostan,
      value: "",
      validation: null,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    city: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
      col: {
        sm: 4,
        xs: 12,
      },
    },
    address: {
      type: "text",
      value: row.Address,
      validation: null,
      col: {
        sm: 12,
        xs: 12,
      },
    },
  });
  const [loading, setLoading] = useState(false);


  const onShowDialog = () => {
    setShowDialog(!showDialog);
  };
  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    setFormValid((prev) => ({ ...prev, [controlName]: true }));
    if (controlName === "ostan") {
      const ctSelectItems = AddressList.city.filter(
        (s) => s.ostan === value.value
      );
      setControls({ city: { selectItems: ctSelectItems } });
      setControls({ city: { value: ctSelectItems[0] } });
    }
  };



  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };
  const onEnter = async () => {
    onClear();
    const ct = AddressList.city.find((c) => c.value === row.IdCity);
    const pr = AddressList.Ostan.find((o) => o.value === ct.ostan);
    const ctSelectItems = AddressList.city.filter((s) => s.ostan === ct.ostan);
    setControls({ ostan: { value: pr } });
    setControls({ city: { value: ct } });
    setControls({ city: { selectItems: ctSelectItems } });
    try {
      setLoading(true);
      const params = { KeyGroup: read(KeyGroup), KeyUser: read(KeyUser) };
      const response = await CustomerService.getGrouhMoshtari(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const moshtariList = response.data.Value;
        const update = moshtariList.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        const groupValue = update.find((g) => g.value === row.IdGroup);
        setControls({customerGroup: {value: groupValue}});
        setControls({customerGroup: {selectItems: update}});
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  const onFinish = async (e) => {
    e.preventDefault();
   
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const {
        name,
        city,
        customerGroup,
        mobile,
        fax,
        telephone,
        shomareEghtesadi,
        address,
      } = controls;
      const enPhone =convertToEnglishNumber(mobile.value)
      const phoneWithCode = enPhone.replace("0" , "+98")
      try {
  
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Name: name.value,
          IdCity: city.value.value,
          IdGroup: customerGroup.value.value,
          Mobile: phoneWithCode,
          Tell: telephone.value,
          Fax: fax.value,
          ShoEconomic: shomareEghtesadi.value,
          Address: address.value,
          Id: row.Id,
        };

        await dispatch(UpdateMoshtariData(data));
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: customerDataPagination.Limit,
          Page: customerDataPagination.Page,
        };
        await dispatch(getAllMoshtariTblData(params));
        onClear();
      } catch (err) {
      console.error('[catch error]', err)
    }
      onShowDialog();
    }else if (R.isEmpty(formValid)) {
      onShowDialog();
    } else {
      showNotify({
        text: t('invalidInformation'),
        customClass: "error",
      });
    }
  };

  const onClear = () => {
    setFormValid({});
    setControls({ name: { value: row.Name } });
    setControls({ shomareEghtesadi: { value: row.ShoEconomic } });
    setControls({ mobile: { value: row.Mobile.replace("+98" , "0") } });
    setControls({ telephone: { value: row.Tell } });
    setControls({ fax: { value: row.Fax } });
    setControls({ customerGroup: { value: row.IdGroup } });
    setControls({ ostan: { value: "" } });
    setControls({ city: { value: "" } });
    setControls({ address: { value: row.Address } });
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="virayesh" />}
        icon={<Icons.Pencil size={17} />}
        className="warning-fill"
        onClick={onShowDialog}
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={onShowDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>
              <Translator id="virayesh_moshtari" />
            </p>
          </div>
          <DialogContent>
            <Grid container spacing={2} >
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid
                    item
                    sm={controls[key].col.sm}
                    xs={controls[key].col.xs}
                    key={key + index}
                  >
                    {controls[key].type === "text" && (
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type="text"
                        value={controls[key].value}
                      />
                    )}
                    {controls[key].type === "phone" && (
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type="text"
                        className={"phone"}
                        maxlength= "11"
                        value={controls[key].value}
                      />
                    )}
                    {controls[key].type === "select" && (
                      <MuiAutoComplete
                        loading={loading}
                        options={controls[key].selectItems}
                        label={<Translator id={key} />}
                        value={controls[key].value}
                        id={key}
                        onChange={autoCompleteHandler}
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={onShowDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default EditCustomer;
